"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function CheckCircle16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.00313 0.199219C9.65413 0.199219 11.2298 0.714278 12.5437 1.65641L11.6114 2.9567C10.567 2.20789 9.31688 1.79922 8.00313 1.79922C4.57896 1.79922 1.80313 4.57505 1.80313 7.99922C1.80313 11.4234 4.57896 14.1992 8.00313 14.1992C11.4273 14.1992 14.2031 11.4234 14.2031 7.99922C14.2031 7.50208 14.1448 7.01322 14.0305 6.53936L15.5858 6.16416C15.7297 6.76066 15.8031 7.37545 15.8031 7.99922C15.8031 12.307 12.3109 15.7992 8.00313 15.7992C3.6953 15.7992 0.203125 12.307 0.203125 7.99922C0.203125 3.6914 3.6953 0.199219 8.00313 0.199219ZM5.43426 6.3854L7.91399 8.86415L14.8238 1.86081L15.9627 2.98455L7.92185 11.1343L4.30311 7.517L5.43426 6.3854Z", fill: "#383F49" }));
}
function CheckCircle16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(CheckCircle16Svg, Object.assign({}, svgProps)));
}
exports.default = CheckCircle16;
//# sourceMappingURL=CheckCircle16.js.map